import React from 'react';

/**
 * TrailMapCard Component
 * Displays trail map with points of interest
 * Specific to hiking/trekking services
 */
export default function TrailMapCard({ mapData }) {
  const { mapImage, trailPoints = [] } = mapData || {};

  return (
    <div className="bg-white rounded-xl p-6 shadow-sm mb-6">
      <h2 className="text-xl font-bold mb-4">Trail Map</h2>
      <div className="relative w-full h-80 bg-gray-200 rounded-lg overflow-hidden">
        {mapImage ? (
          <img
            src={mapImage}
            alt="Trail map"
            className="w-full h-full object-cover"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-gray-400">
            <div className="text-center">
              <svg className="mx-auto h-12 w-12 text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
              </svg>
              <p className="mt-2 text-sm">Trail map coming soon</p>
            </div>
          </div>
        )}
        {trailPoints.length > 0 && (
          <div className="absolute top-4 right-4 bg-white rounded-lg shadow-lg p-3 text-xs">
            <div className="font-semibold mb-2">Trail Points</div>
            <div className="space-y-1">
              {trailPoints.map((point, idx) => (
                <div key={idx} className="flex items-center gap-2">
                  <div
                    className="w-3 h-3 rounded-full"
                    style={{ backgroundColor: point.color || '#059669' }}
                  ></div>
                  <span>{point.name}</span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
